export var EMPTY_SECTION = {
  id: '',
  name: ''
};